var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ma-2",attrs:{"outlined":"","flat":""}},[_vm._v(" "+_vm._s(_setup.connectionState)+" [ "+_vm._s(_setup.activeChannelCount)+" ] "),_c('span',{staticClass:"cursor-pointer text-primary",on:{"click":_setup.echoDump}},[_vm._v("dump")])])
}
var staticRenderFns = []

export { render, staticRenderFns }